export const CRITERION_KEYS = [
  "IsItDisplayed",
  "IsItCleanAndPerfect",
  "DoesItHaveTag",
  "AreBuyInstructionClear",
  "IsItPlacedAndGroupInRangeArea",
  "IsItAvailableInIndicatedPosition",
] as const;

export type CriterionKey = (typeof CRITERION_KEYS)[number];

export type FailedCriteriaComment = {
  initial_comment: boolean;
  creator_user_id: string;
  title: string;
  text: string;
  created_at: string;
};

export type FailedCriteriaItem = {
  type: CriterionKey;
  completed: boolean;
  comments: FailedCriteriaComment[];
};
